export default "__VITE_ASSET__BBzJxmi5__"